import { makeStyles } from 'tss-react/mui';

const Style = makeStyles()(theme => {
  const isLight = theme.palette.mode === 'light';

  return {
    chart: {
      padding: theme.spacing(2),
      height: 240
    },
    card: {
      padding: theme.spacing(2),
      backgroundColor: isLight ? '#FFFFFF' : '#1C1C28',
      border: isLight ? '1px solid rgba(0,0,0,0.08)' : 'none',
      borderTop: '3px solid transparent',
      borderRadius: 8,
      minHeight: 168,
      boxSizing: 'border-box'
    },
    border_info: {
      borderTopColor: theme.palette.info.main
    },
    border_error: {
      borderTopColor: theme.palette.error.main
    },
    border_success: {
      borderTopColor: theme.palette.success.main
    },
    title: {
      color: isLight ? theme.palette.text.secondary : '#9E9EAE',
      fontSize: 14
    },
    value: {
      color: isLight ? theme.palette.text.primary : '#FAFAFA',
      fontWeight: 700,
      fontSize: 28,
      marginTop: theme.spacing(0.5)
    },
    statRow: {
      marginTop: theme.spacing(1.5)
    },
    statText: {
      color: isLight ? theme.palette.text.secondary : '#9E9EAE',
      fontSize: 13
    },
    text_info: {
      color: isLight ? theme.palette.info.dark : theme.palette.info.light
    },
    text_error: {
      color: isLight ? theme.palette.error.dark : theme.palette.error.light
    },
    text_success: {
      color: isLight ? theme.palette.success.dark : theme.palette.success.light
    },
    progress: {
      marginTop: theme.spacing(1),
      height: 6,
      borderRadius: 3,
      backgroundColor: isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.08)'
    },
    bar_info: {
      backgroundColor: theme.palette.info.main
    },
    bar_error: {
      backgroundColor: theme.palette.error.main
    },
    bar_success: {
      backgroundColor: theme.palette.success.main
    },
    caption: {
      color: isLight ? theme.palette.text.disabled : '#78788A',
      fontSize: 12,
      marginTop: theme.spacing(0.5)
    },
    tooltip: {
      backgroundColor: theme.palette.background.default,
      padding: theme.spacing(2),
      borderRadius: 4
    }
  };
});

export default Style;